import { Button, Table, addToast } from '@octano/global-ui';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationsKeys } from '../../../../../../locales/translations';
import { saveCertificatePricesRequest } from '../api';
import usePriceColumns from '../hooks/usePriceColumns';
import { usePricingLoader } from '../Loader';
import { CertificateType } from '../types';

export default function CertificatesSection() {
  const { t } = useTranslation(
    TranslationsKeys.CONFIGURATION_FIANANTIAL_OTHERS,
  );
  const { data } = usePricingLoader();

  const [rows, setRows] = useState<CertificateType[]>(
    data?.certificateTypes ?? [],
  );
  // La celda del checkbox es no controlada (defaultChecked): remontar la tabla
  // es lo que la deja en sincronía con el estado al marcar/desmarcar.
  const [tableKey, setTableKey] = useState(0);
  const [saving, setSaving] = useState(false);

  const columns = usePriceColumns({
    translateKey: 'certificateTypes',
    onChangeValue: (typeId, fieldName, fieldValue) => {
      setRows((prev) =>
        prev.map((row) =>
          row.id === typeId ? { ...row, [fieldName]: fieldValue } : row,
        ),
      );
    },
    onCheck: (typeId, paymentRequired) => {
      setTableKey((prev) => prev + 1);
      setRows((prev) =>
        prev.map((row) =>
          row.id === typeId
            ? {
                ...row,
                paymentRequired,
                paymentAmount: paymentRequired ? row.paymentAmount : undefined,
              }
            : row,
        ),
      );
    },
  });

  const onSave = useCallback(async () => {
    setSaving(true);
    const { error } = await saveCertificatePricesRequest(rows);
    setSaving(false);
    addToast(
      error
        ? { icon: 'error', color: 'danger', text: t('onSaveError') }
        : { icon: 'success', color: 'success', text: t('onSaveSuccess') },
    );
  }, [rows, t]);

  return (
    <div>
      <p className="fs-16 fw-600 text-primary mb-0">
        {t('certificateTypes.title')}
      </p>
      <p className="fs-14 mb-3">{t('certificateTypes.description')}</p>
      <Table key={tableKey} columns={columns} data={rows} />
      <div className="d-flex justify-content-end mt-3">
        <Button
          text={t('save')}
          size="md"
          disabled={saving}
          loading={saving}
          onClick={onSave}
        />
      </div>
    </div>
  );
}
